
import React from 'react';
import { StarryBackground } from './StarryBackground';

// Data for cards - easier to manage
const friends = [
];

const contributors = [
  { name: 'Danish crypto', role: 'SEO Specialist', img: '/Danish.jpg', link: 'https://t.me/danishcrypto', x_link: 'https://x.com/DanishCryptoDK' },
  { name: 'Jake de la doge', role: 'Developer', img: '/Jake.jpg', link: 'https://t.me/jakedeladoge' },
];

// Reusable Card Component
const ContactCard = ({ name, role, img, link, x_link }: { name: string, role: string, img: string, link: string, x_link?: string }) => (
  <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-lg p-6 text-center shadow-lg transition-all duration-300 hover:border-orange-500 hover:shadow-2xl hover:-translate-y-2 flex flex-col">
    <div className="flex-grow">
      <img src={img} alt={name} className="w-24 h-24 rounded-full mx-auto mb-4 border-2 border-gray-600" />
      <h3 className="text-xl font-bold text-white">{name}</h3>
      {role && <p className="text-orange-400 mb-4">{role}</p>}
    </div>
    <div className="flex justify-center items-center gap-2 mt-4">
        <a href={link} target="_blank" rel="noopener noreferrer" className="flex-1 px-4 py-2 text-sm bg-gray-700 hover:bg-gray-600 text-white rounded-md transition-colors">
          Telegram
        </a>
        {x_link && (
          <a href={x_link} target="_blank" rel="noopener noreferrer" className="flex-1 px-4 py-2 text-sm bg-gray-700 hover:bg-gray-600 text-white rounded-md transition-colors">
            X.com
          </a>
        )}
    </div>
  </div>
);

const ContactsPage = () => {
  return (
    <>
      <StarryBackground />
      <main className="max-w-7xl mx-auto p-6 md:p-8 text-white">
        <header className="text-center my-12 md:my-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Network</h1>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
            This project is built on the passion of a global community. Connect with the people and projects that make XMRmap possible.
          </p>
        </header>

        {/* Project Connect Section */}
        <section className="text-center my-16">
          <h2 className="text-3xl font-bold text-center mb-8">Join the Community</h2>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 max-w-lg mx-auto">
            <a href="https://t.me/XMRmap" target="_blank" rel="noopener noreferrer" className="w-full text-center px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-lg transition-colors">
              Project Telegram
            </a>
            <a href="https://t.me/XMRmap_bot" target="_blank" rel="noopener noreferrer" className="w-full text-center px-6 py-3 bg-gray-600 hover:bg-gray-500 text-white font-semibold rounded-lg transition-colors">
              Project Bot
            </a>
          </div>
        </section>

        {/* Friends Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-8">Friends of the Project</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {friends.map(friend => <ContactCard key={friend.name} {...friend} />)}
          </div>
        </section>

        {/* Contributors Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-8">Core Contributors</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {contributors.map(contrib => <ContactCard key={contrib.name} {...contrib} />)}
          </div>
        </section>

        {/* Sponsors Section */}
        <section>
          <h2 className="text-3xl font-bold text-center mb-8">Valued Sponsors</h2>
          <div className="flex justify-center items-center h-40 bg-gray-800/30 border-2 border-dashed border-gray-700 rounded-lg">
            <p className="text-gray-400">Sponsorship opportunities coming soon...</p>
          </div>
        </section>
      </main>
    </>
  );
};

export default ContactsPage;

